import { PurchaseStateAndDelivery } from "@smartrr/shared/entities/PurchaseState";

import { ViewInfo } from "../../types";
import { useBasicSubscriptionInfo } from "../useBasicSubscriptionInfo";

export const useShowModalButtons = (
  delivery: PurchaseStateAndDelivery,
  viewInfo: ViewInfo,
  areThemeConditionalActions: boolean
) => {
  const { isPaused, isSellingPlanDeleted } = useBasicSubscriptionInfo(delivery);

  const initCondition = !isSellingPlanDeleted && viewInfo.view !== "Swap Plan" && areThemeConditionalActions;

  //disabled if sub is paused and user clicked on "Change auto-resume date"
  if (viewInfo.view === "Pause") {
    return !isPaused && initCondition;
  }

  return initCondition;
};
